/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Defaultlocation_Number_Placeholder1Inputs */

const en__field_defaultlocation_number_placeholder1 = /** @type {(inputs: _Field_Defaultlocation_Number_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

/**
* | output |
* | --- |
* | "Number" |
*
* @param {_Field_Defaultlocation_Number_Placeholder1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_defaultlocation_number_placeholder1 = /** @type {((inputs?: _Field_Defaultlocation_Number_Placeholder1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Defaultlocation_Number_Placeholder1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_defaultlocation_number_placeholder1(inputs)
});
export { _field_defaultlocation_number_placeholder1 as "_field_defaultLocation_number_placeholder" }